import { getService } from "../../reducers/service";
import { serviceNames } from "../../utils/constants";

export const getVehicleData = async (id) => {
	const service = await getService(serviceNames.perVehicles);
	return service.find({
		query: {
			id,
			isDeleted: false,
		},
	});
};

export const updateVehicleData = async (id, data) => {
	const service = await getService(serviceNames.perVehicles);
	const response = await service.patch(id, data);
	return response;
};

export const getMakeOptions = async (userAgency) => {
	const service = await getService(serviceNames.perVehicleMakeOptions);
	const response = await service.find({
		query: {
			agencyId: userAgency,
			isDeleted: false,
		},
	});

	return response?.map((value) => ({
		label: value,
		value,
	}));
};

export const getModelOptions = async (userAgency) => {
	const service = await getService(serviceNames.perVehicleModelOptions);
	const response = await service.find({
		query: {
			agencyId: userAgency,
			isDeleted: false,
		},
	});

	return response?.map((value) => ({
		label: value,
		value,
	}));
};

export const getYearOptions = async (userAgency) => {
	const service = await getService(serviceNames.perVehicleYearOptions);
	const response = await service.find({
		query: {
			agencyId: userAgency,
			isDeleted: false,
		},
	});

	return response?.map((value) => ({
		label: value,
		value,
	}));
};
